import { IconName } from "@fortawesome/fontawesome-common-types";
import { SupportedLanguages } from "./language";

export enum BANNER_CONDITIONS {
  MIGRATION = "migration",
}

export enum SITES {
  MARKETING = "marketing",
  DASHBOARD = "dashboard",
  DASHBOARD_PUBLIC = "dashboard-public",
}

export type LangString = Partial<Record<SupportedLanguages, string>>;

export type BannerLink = {
  type: "url" | "id";
  value: string;
  text: LangString;
};

export type BannerItem = {
  id: string;
  sites: SITES[];
  icon: IconName;
  description: Partial<Record<SupportedLanguages, string>>;
  status: "success" | "error" | "warning" | "info";
  isPersistent: boolean;
  links?: BannerLink[];
  condition?: BANNER_CONDITIONS;
  startDate?: string;
  endDate?: string;
};

/** Resolves a banner link to an href for Next.js `Link` / `<a>`. */
export function resolveBannerLinkHref(link: BannerLink): string {
  if (link.type === "url") {
    return link.value;
  }
  return link.value.startsWith("#") ? link.value : `#${link.value}`;
}
